import { DesignSystemContent } from "@shared-kernel/primary/shared/design-system/design-system.content";

export const DesignSystemPage = () => {
  return (
    <div className="mx-auto my-5 w-[90%]">
      <DesignSystemContent />
    </div>
  );
};
